import * as React from "react";
import './Progress.css'
interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number; // Progressvärde 0-100
  className?: string;
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className = "", value = 0, ...props }, ref) => {
    const clampedValue = Math.max(0, Math.min(100, value)); // säkerställ att value är 0-100

    return (
      <div
        ref={ref}
        className={`progressRoot ${className}`}
        {...props}
      >
        <div
          className="progressIndicator"
          style={{ width: `${clampedValue}%` }}
        />
      </div>
    );
  }
);

Progress.displayName = "Progress";

export { Progress };
